import { render } from "./History.vue?vue&type=template&id=ec8df556&ts=true"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__